import type { ConceptDef } from '../types';

export const letterId: ConceptDef = {
  kind: 'tileMatch',
  id: 'letter-id',
  label: 'Letter ID',
  category: 'Literacy',
  description: 'Hear a letter name; tap the matching uppercase letter.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'letter A', answer: 'A' },
      { say: 'letter B', answer: 'B' },
      { say: 'letter C', answer: 'C' },
      { say: 'letter D', answer: 'D' },
      { say: 'letter E', answer: 'E' },
      { say: 'letter F', answer: 'F' },
      { say: 'letter G', answer: 'G' },
      { say: 'letter H', answer: 'H' },
    ],
  },
};
